var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.375,
    stroke: "#F1964F",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 21C18.8137 21 21.5 18.3137 21.5 15C21.5 11.6863 18.8137 9 15.5 9C12.1863 9 9.5 11.6863 9.5 15C9.5 18.3137 12.1863 21 15.5 21ZM15.5 10.7C15.7761 10.7 16 10.9238 16 11.2V14.7101L17.3826 16.7839C17.5357 17.0137 17.4737 17.3241 17.2439 17.4773C17.0141 17.6305 16.7037 17.5684 16.5505 17.3386L15.1819 15.2858C15.0708 15.1941 15 15.0553 15 14.9V11.2C15 10.9238 15.2239 10.7 15.5 10.7Z",
    fill: "#F1964F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHours);
export default __webpack_public_path__ + "static/media/Hours.9ab6bd7852d72aa6f9fe106e75d3dacd.svg";
export { ForwardRef as ReactComponent };